import * as React from 'react';
import type { SVGProps } from 'react';
const SvgCommentHeart = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width="1em"
    height="1em"
    color="currentColor"
    {...props}
  >
    <path d="M12 8.35a3.07 3.07 0 0 0-3.54.53 3 3 0 0 0 0 4.24L11.29 16a1 1 0 0 0 1.42 0l2.83-2.83a3 3 0 0 0 0-4.24A3.07 3.07 0 0 0 12 8.35m2.12 3.36L12 13.83l-2.12-2.12a1 1 0 0 1 0-1.42 1 1 0 0 1 1.41 0 1 1 0 0 0 1.42 0 1 1 0 0 1 1.41 0 1 1 0 0 1 0 1.42M12 2A10 10 0 0 0 2 12a9.9 9.9 0 0 0 2.26 6.33l-2 2a1 1 0 0 0-.21 1.09A1 1 0 0 0 3 22h9a10 10 0 0 0 0-20m0 18H5.41l.93-.93a1 1 0 0 0 0-1.41A8 8 0 1 1 12 20" />
  </svg>
);
export default SvgCommentHeart;
